export default __webpack_public_path__ + "static/media/information--minimum-speed-70--g1.c8d65d5e.png";